import * as React from 'react';
import { useLayoutEffect } from './useLayoutEffect';
/**
 * Work as `componentDidUpdate`
 */

export default function useUpdateEffect(callback, condition) {
  var initRef = React.useRef(false);
  useLayoutEffect(function () {
    if (!initRef.current) {
      initRef.current = true;
      return undefined;
    }

    return callback();
  }, condition);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/rc-input-number/es/hooks/useUpdateEffect.js
// module id = 3045
// module chunks = 0